// @module Tavano.GoogleFix.GoogleFix
define('Tavano.GoogleFix.GoogleFix.View'
	, [
		'GoogleTagManager'
		, 'Utils'
		, 'Backbone'
		, 'jQuery'
		, 'underscore'
        , 'Tracker'
		, 'LiveOrder.Model'
		, 'GoogleTagManager.Model'
		, 'SC.Configuration'
		, 'GoogleTagManager.NavigationHelper.Plugins.Standard'
	]
	, function (
		GoogleTagManager
		, Utils
		, Backbone
		, jQuery
		, _
        , Tracker
		, LiveOrderModel
		, GoogleTagManagerModel
		, Configuration
		, GoogleTagManagerNavigationHelper
	) {
		'use strict';

		// @class Tavano.GoogleFix.GoogleFix.View @extends Backbone.View
		_.extend(GoogleTagManager, {
			tracking_product_list: false,
			mountToApp: function(application){
				console.log('GoogleTagManager mounted to app');
				var self = this;
				var win = window;
				this.user = '';
				application.getUser().done(function (resp) {
					self.user = resp;
				});

				// If the SEO is processing, we do not want GoogleTagManager
				if (SC.isPageGenerator())
					return
				this.configuration = Configuration.get('tracking.googleTagManager');

				if (!this.configuration || !this.configuration.id) return;

				this.configuration.dataLayerName = this.configuration.dataLayerName || 'dataLayer';

				win[this.configuration.dataLayerName] = [];

				var layout = application.getLayout();

				// Install Standard Navigation Plugins
				layout.mouseDown.install({
					name: 'googleTagManagerStandardNavigation',
					priority: 20,
					execute: function(e) {
						return GoogleTagManagerNavigationHelper.mouseDownNavigation(layout, e);
					}
				});

				this.model = new GoogleTagManagerModel();

				win[this.configuration.dataLayerName].push({
					'gtm.start': new Date().getTime(),
					event: 'gtm.js'
				});

				Tracker.getInstance().trackers.push(GoogleTagManager);
				// the analytics script is only loaded if we are on a browser
				application
					.getLayout()
					.once('afterAppendView', function() {
						var script_loaded = jQuery.proxy(GoogleTagManager, 'loadScript')();
						if(script_loaded){
							script_loaded.done(function() {
								// Tracker.getInstance().trackers.push(GoogleTagManager);
							}).fail(function(jqXhr){
								jqXhr.preventDefault = true;
								console.warn('trackers disabled');
							});
						}
					});
			},

			trackLogin: function (event) {
				var eventData = {
					name: 'login',
					category: event.category,
					action: event.action,
					callback: event.callback
				};
				this.trackEvent(eventData);
			},
			trackPageview: function (url) {

				var finishFunc = false;
				_.each(window.dataLayer, function (element) {
					if (element.data) {
						// This is to avoid duplicate checkoutView when checkout page is loaded from login page
						if (element.event == "pageView" &&
							element.data.page ==  url) {
							finishFunc = true;
						}
					}
				})
				if (finishFunc) {
					return;
				}



				if (_.isString(url)) {
					var eventName = 'pageView';
					var eventData = {
						event: eventName,
						data: {
							page: url
						}
					};

					// Triggers a Backbone.Event so others can subscribe to this event and add/replace
					// data before is send it to Google Tag Manager
					Tracker.trigger(eventName, eventData, url);

					this.pushData(eventData);

				}

				return this;
			},
			trackRemoveFromCart: function (line) {
				line = line[0];
				if (line) {
					var selected_options = line.get('options').filter(function (option) {
						return option.get('value') && option.get('value').label;
					});
					var item = line.get('item');
					var opt = line.getOption("custcol_tt_google_category") ? line.getOption("custcol_tt_google_category").get('value').label : this.getCategory();
					var brand = line.getOption("custcol_tt_google_brand") ? line.getOption("custcol_tt_google_brand").get('value').label : "";
					var eventName = 'removeFromCart';
					var eventData = {
						event: eventName,
						ecommerce: {
							currencyCode: SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl,
							remove: {
								products: [
									{
										id: item.get('itemid'),
										name: item.get('_name'),
										price: item.get('_priceDetails').onlinecustomerprice,
										variant: _.map(selected_options, function (option) {
											return option.get('value').label;
										}).join(', '),
										category: opt,
										quantity: line.get('quantity'),
										brand: brand
									}
								]
							}
						}
					};

					Tracker.trigger(eventName, eventData, line);
					this.pushData(eventData);
				}
			},
			trackPageviewForCheckoutStep: function (step) {

				var finishFunc = false;
				_.each(window.dataLayer, function (element) {
					// This is to avoid duplicate checkoutView when checkout page is loaded from login page
					if (element.event == "checkoutView" &&
						element.ecommerce && element.ecommerce.checkout &&
						element.ecommerce.checkout.actionField &&
						element.ecommerce.checkout.actionField.step == step) {
						finishFunc = true;
					}
				});
				if (finishFunc) {
					return;
				}
				var eventName = 'checkoutView';
				var eventData = {
					event: eventName,
					ecommerce: {
						checkout: {
							actionField: { step: step }
						}
					}
				};


				// Triggers a Backbone.Event so others can subscribe to this event and add/replace data
				// before is send it to Google Tag Manager
				Tracker.trigger(eventName, eventData);
				this.pushData(eventData);

				return this;
			},
			trackAddToCart: function (line) {

				if (line) {
					var selected_options = line.get('options').filter(function (option) {
						return option.get('value') && option.get('value').label;
					});

					var item = line.get('item');
					if (item.id !== '196080') {
						var opt = line.getOption("custcol_tt_google_category") ? line.getOption("custcol_tt_google_category").get('value').label : this.getCategory();
						var brand = line.getOption("custcol_tt_google_brand") ? line.getOption("custcol_tt_google_brand").get('value').label : "";
						var eventName = 'addToCart';
						var eventData = {
							event: eventName,
							ecommerce: {
								currencyCode: 'USD',
								add: {
									products: [
										{
											id: item.get('itemid'),
											name: item.get('_name'),
											price: item.get('_priceDetails').onlinecustomerprice,
											variant: _.map(selected_options, function (option) {
												return option.get('value').label;
											}).join(', '),
											category: opt,
											quantity: line.get('quantity'),
											brand: brand
										}
									]
								}
							}
						};
						// Triggers a Backbone.Event so others can subscribe to this event and add/replace
						// data before is send it to Google Tag Manager
						Tracker.trigger(eventName, eventData, line);
						this.pushData(eventData);

					}
				}
				return this;
			},
			trackProductList: function (items, listName) {
				return this.trackProductListGeneric('productList', items, listName);
			},
			trackTransaction: function (transaction) {

                var estgrossprofit = LiveOrderModel.getInstance().get('confirmation').estgrossprofit;
				var self = this;
				var eventName = 'transaction';
				var eventData = {
					event: eventName,
					ecommerce: {
						purchase: {
							actionField: {
								id: transaction.get('confirmationNumber'),
								affiliation: '',
								revenue:
									transaction.get('subTotal') +
									transaction.get('taxTotal') +
									transaction.get('shippingCost') +
									transaction.get('handlingCost'),
                                subtotal: transaction.get('subTotal'),
                                metric1: estgrossprofit,
								tax: transaction.get('taxTotal'),
								shipping: transaction.get('shippingCost') + transaction.get('handlingCost'),
								coupon: [],
								currency: 'USD'
							},
							products: []
						}
					}
                };
				var url = '/app/site/hosting/scriptlet.nl?script=345&deploy=1&compid=1250437&ns-at=AAEJ7tMQzcHrOyWCQJU_aQolV2H3Gzn1woz-m05wSp-QvntZ2Bk&orderId=' + transaction.get('confirmationNumber');
				jQuery.ajax({
					url: url,
					async: true,
					success: function (results) {

						results = JSON.parse(results)
						_.each(results, function (product) {
							eventData.ecommerce.purchase.products.push({
								name: product.name,
								id: product.id,
								price: product.price,
								category: '',
								variant: '',
								quantity: product.quantity
							});
						});
						// Tracker.trigger(eventName, eventData, transaction);
						self.pushData(eventData);
					}
				});



				// _.each(transaction.get('promocodes'), function () {
				// 	if (promo) {
				// 		eventData.ecommerce.purchase.actionField.coupon.push(promo.code);
				// 	}
				// });


				// Triggers a Backbone.Event so others can subscribe to this event and add/replace data before is send it to Google Tag Manager


				return this;
			},

			trackProductListGeneric: function (eventName, items, listName) {
				if (this.tracking_product_list) {
					this.resetTracker();
				}

				this.tracking_product_list = true;
				var self = this;
				var eventData = {
					event: eventName,
					ecommerce: {
						currencyCode: SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl,
						impressions: []
					},
					page: this.getCategory(),
					list: listName,
					label: listName
				};

				_.each(items.models, function (item, index) {
					var commerceCategories = item.get('commercecategory');
					if (commerceCategories && commerceCategories.categories && commerceCategories.categories.length > 0) {
						var cat = commerceCategories.categories[commerceCategories.categories.length - 1].name;
					}
					var brand = item.get('custitem_attr_brand_name');
					// We set this properties in the item so we can print them on the html, to later be read them by the trackProductClick event
					item.set('track_productlist_position', index + 1);
					item.set('track_productlist_category', self.getCategory());
					item.set('track_productlist_list', listName);

					eventData.ecommerce.impressions.push({
						name: item.get('_name'),
						id: item.get('_sku', true),
						price: (item.get('_price') && item.get('_price').toFixed(2)) || 0.0,
						list: item.get('track_productlist_list'),
						position: item.get('track_productlist_position'),
						category: cat,
						brand: brand
					});
				});

				// Triggers a Backbone.Event so others can subscribe to this event and add/replace data before is send it to Google Tag Manager
				Tracker.trigger(eventName, eventData, items);
				this.pushData(eventData);

				this.resetTracker();

				this.tracking_product_list = false;

				return this;
			},
			resetTracker: function () {
				if (window.google_tag_manager) {
					window.google_tag_manager[this.configuration.id].dataLayer.reset();
				} else {
					window[this.configuration.dataLayerName].push({
						event: 'dataLayerReset',
						data: undefined,
						eventCallback: undefined
					});
				}
			}



		});

	});
